@for (option of options; track option; let i = $index) {
  <div class="changelog-activity">
    {{ getTranslation()(option) }}
  </div>
}
